import React, { InputHTMLAttributes } from 'react'
import styled, { css } from 'styled-components'
import { $DCprimaryColor, colors } from '../styleGuide'
import check from './assets/check.svg'
import disablecheck from './assets/disableCheck.svg'
import cross from './assets/cross.svg'
import disablecross from './assets/disableCross.svg'

export interface SwitchProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string
  label?: string
  name: string
  endLabel?: string
  size?: any
}

const StyledPixelSwitch = styled.div`
  ${(props: SwitchProps) =>
    props.size === 'sm' &&
    css`
      padding: 5px !important;
      border-radius: 5px !important;
    `}
  padding: 10px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  border: 1px ${colors.switchBorder} solid;
  input[type='checkbox'] {
    height: 0;
    width: 0;
    visibility: hidden;
  }
  input {
    &:checked {
      + {
        label {
          background: ${colors.switchPurple};
          &:hover {
            background: ${$DCprimaryColor};
          }
          &:after {
            background: ${colors.white};
            content: '';
            left: 34px;
            transform: translateX(-100%);
            background-image: url(${check});
          }
        }
      }
    }
  }
  &.disable {
    pointer-events: none;
    label {
      background: ${colors.switchGrayLight};
      border: 1px solid ${colors.switchGrayMedium};
      &:hover {
        background: ${colors.switchGrayLight} !important;
      }
      &:after {
        top: 1px;
        background: ${colors.switchGrayMedium};
        background-image: url(${disablecross});
      }
    }
    input {
      &:checked {
        + label {
          background: ${colors.switchGrayLight};
          &:after {
            left: calc(100% - 1px);
            background: ${colors.switchGrayMedium};
            background-image: url(${disablecheck}) !important;
            background-repeat: no-repeat !important;
            background-size: 10px !important;
            background-position: center center !important;
          }
        }
      }
    }
  }
  &.large {
    label {
      width: 44px;
      height: 24px;
      &:hover {
        background: ${$DCprimaryColor};
      }
      &:after {
        /* left: calc(100% - 2px); */
        width: 20px;
        height: 20px;
      }
    }
    input {
      &:checked {
        + label {
          &:after {
            left: calc(100% - 2px);
            background-image: url(${check});
          }
          &.disablee {
            &:after {
              left: calc(100% - 1px);
              background-size: 14px !important;
            }
          }
        }
      }
    }
  }
  label {
    cursor: pointer;
    width: 36px;
    height: 20px;
    background: ${colors.switchPurple};
    display: block;
    border-radius: 12px;
    position: relative;
    &:hover {
      background: ${$DCprimaryColor};
    }
    &:after {
      content: '';
      position: absolute;
      top: 2px;
      left: 2px;
      width: 16px;
      height: 16px;
      background: ${colors.white};
      border-radius: 90px;
      transition: 0.3s;
      display: flex;
      justify-content: center;
      align-items: center;
      color: ${colors.white};
      background-image: url(${cross});
      background-repeat: no-repeat !important;
      background-size: 10px !important;
      background-position: center center !important;
    }
    &:active {
      &:after {
        width: 30px;
      }
    }
  }
`

const StyledLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${colors.switchTextDark};
  margin-right: 5px;
`

export const PixelSwitch = React.forwardRef<HTMLInputElement, SwitchProps>(
  (
    { className, label, endLabel = false, disabled = false, size, ...rest },
    ref
  ) => {
    const id = `check_${Math.random()}`
    return (
      <StyledPixelSwitch
        size={size}
        className={`${className} ${disabled === true && 'disable'}`}
      >
        <StyledLabel>{label}</StyledLabel>
        <input type='checkbox' {...rest} id={id} ref={ref} />
        <label
          className={`${className} ${disabled === true && 'disablee'}`}
          htmlFor={id}
        ></label>
        {endLabel && <StyledLabel>{endLabel}</StyledLabel>}
      </StyledPixelSwitch>
    )
  }
)
export default PixelSwitch
